/** @jsx CanvaSX */
import ObjectValue, { type FieldObjectType } from './ObjectValue';
import type WhiteboardController from '../controllers/WhiteboardController';
import FieldCanvaSXComponents from '../components/fields/canvasx';
import type DataStoreFields from '../collaboration/DataStoreFields';
import { fieldsEnabled } from '../controllers/FieldsController';

export const fieldableSerializedKeys = [/field_value_.*/];

class FieldObjectValue extends ObjectValue {
  fieldsStore: DataStoreFields;

  static shouldRender(
    object: FieldObjectType,
    controller: WhiteboardController
  ): boolean {
    if (!fieldsEnabled()) return false;

    const fieldsStore = controller.dataStoreForKey('fields') as DataStoreFields;
    if (!fieldsStore) return false;

    return fieldsStore.visibleFields.length > 0;
  }

  static renderFields(
    maxChildWidth: number,
    object: FieldObjectType,
    controller: WhiteboardController
  ): CanvaSXNode[] {
    const fieldsStore = controller.dataStoreForKey('fields') as DataStoreFields;

    if (!fieldsEnabled() || !fieldsStore) {
      return [];
    }

    return fieldsStore.visibleFields
      ?.map(field => {
        const Component = FieldCanvaSXComponents[field.type];

        if (Component) {
          const value = field.valueForObject(object);
          const content = Component(field, object, value, maxChildWidth);

          if (content) return content;
        }

        return null;
      })
      .filter(Boolean);
  }
}

export default FieldObjectValue;
